'use client'

import './footer.css'

import alrajhiLogo from '@/assets/images/alrajhi_logo.svg'
import pidmLogo from '@/assets/images/pidm_logo.webp'
import Link from '@/components/Link'
import useStore from '@/stores/Store'

const PIDM_DIS = '/pdfs/PIDM_DIS.pdf'
const tnc = '/pdfs/website_terms_of_use.pdf'

const MainFooter = () => {
  const { setShowTips } = useStore()
  const year = new Date().getFullYear()

  return (
    <div id="footer" className="mt-5">
      <div className="footer">
        <div className="container footer-top">
          <div className="row gy-5">
            <div className="col-lg-2 d-flex flex-lg-column flex-row align-items-center justify-content-start">
              <Link href="/" className="logo d-flex align-items-center">
                {/* height 42 + contain replicates the old inline <svg width=145>:
                    SVG width/height attrs don't preserve ratio, so prod renders a
                    145x42 box with the artwork letterboxed inside. A bare <img>
                    scales by aspect ratio to 46px and shifts the whole footer. */}
                <img
                  src={alrajhiLogo.src}
                  alt="al rajhi bank"
                  width="145"
                  height="42"
                  loading="lazy"
                  decoding="async"
                  className="d-inline-block align-top"
                  style={{ paddingRight: '16px', objectFit: 'contain' }}
                />
              </Link>
            </div>

            <div className="col-lg-2 col-6 footer-links al">
              <h4 data-translate="footer_1_1">I need to know</h4>
              <div className="links">
                <Link href="/foreign-exchange-rates">Exchange Rates</Link>

                {/* <Link
                  href={
                    'https://www.alrajhibank.com.my/assets/pdf/reference-rates/reference-rates.pdf'
                  }
                  target="blank"
                >
                  Reference Rates
                </Link>
                */}

                {/* <Link href="/unit-trust-price">
                  <span data-translate="footer_1_4">Unit Trusts-</span>
                  <em>i</em>
                </Link> */}

                <Link href="/e-application-form">e-Application Form</Link>

                <Link
                  href={
                    'https://www.alrajhibank.com.my/assets/pdf/feesandcharges/Tariff_Charges.pdf'
                  }
                  target="blank"
                >
                  Fees and Charges
                </Link>

                <Link href="/negative-list">Negative List</Link>

                {/* <Link
                  href={`https://www.alrajhibank.com.my/assets/files/FEP_FAQ_Customer_V2_0_e33f84f6ec.pdf`}
                  target="blank"
                >
                  Foreign Exchange Policy (FEP) FAQ
                </Link>
                */}

                <Link href="/list-of-insured-deposits">List of Insured Deposits</Link>

                <Link href="/auctions">Auctions</Link>

                <Link href="/about/corporate-governance/compliance">
                  Personal Data Protection Notice
                </Link>

                <Link href="/about/corporate-governance/whistleblow">Whistleblowing Policy</Link>

                <button type="button" className="footer-link-btn" onClick={() => setShowTips(true)}>
                  Security Tips
                </button>

                <Link href="/reliefandsupport">Relief and support </Link>
              </div>
            </div>

            {/*
            <div className="col-lg-2 col-6 footer-links">
              <h4 data-translate="footer_2_1">Promotions</h4>
              <div className="links">
                <Link href="/personal/cards/debit-card">
                  <span>Debit Card-</span>
                  <em>i</em>
                </Link>
              </div>
            </div>

            */}

            <div className="col-lg-3 col-6 footer-links">
              <h4 data-translate="footer_3_1">Wealth Management</h4>
              <div className="links">
                <Link href="/personal/wealth/gold-i">
                  <span>Gold-</span>
                  <em>i</em>
                </Link>

                {/*  <Link href="/gold-price">Gold Price</Link> */}

                <Link href="/personal/wealth/gold-investment-account">
                  <span>GoldInvest-</span>
                  <em>i</em>
                </Link>

                <Link href="/personal/wealth/unit-trust">Unit Trust</Link>

                <Link href="/personal/wealth/sinar-kasih">BancaTakaful</Link>

                <Link href="/personal/wealth/structured-product">
                  Structured Product-<em>i</em>
                </Link>

                <Link href="/personal/wealth/will-writing">Will Writing</Link>

                <Link href="/personal/wealth/safe-deposit-box">
                  Safe Deposit Box-<i>i</i>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-6 footer-links">
              <h4 data-translate="footer_4_1">Corporate Info</h4>
              <div className="links">
                <Link href="/about">About Us</Link>
                <Link href="/about/corporate-info/our-background">Our Background</Link>
                <Link href="/about/corporate-info/our-values">Our Values</Link>
                <Link href="/about/corporate-governance/compliance">
                  Compliance & AML Statement
                </Link>
              </div>
            </div>

            <div className="col-lg-2 col-12 footer-contact text-md-start">
              <h4 data-translate="footer_5_1">Our Contact</h4>
              <div className="contact-info">
                <div className="contact-row">
                  <i
                    className="bi bi-telephone-fill"
                    style={{
                      color: 'rgba(0, 0, 69, 0.70)',
                      fontSize: '20px'
                    }}
                  ></i>
                  <p>
                    <b>Customer Care Hotline:</b>
                    <br />
                    <a
                      href="tel:+60323326000"
                      style={{
                        color: 'rgba(0, 0, 69, 0.70)'
                      }}
                    >
                      +603-2332 6000
                    </a>
                  </p>
                </div>
                <div className="contact-row">
                  <i
                    className="bi bi-geo-alt-fill"
                    style={{
                      color: 'rgba(0, 0, 69, 0.70)',
                      fontSize: '20px'
                    }}
                  ></i>
                  <p>
                    <b>
                      alrajhi bank Malaysia<br></br>
                      <Link
                        href="/contact-us"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      >
                        Location
                      </Link>
                    </b>
                  </p>
                </div>
                <div className="contact-row pt-4 text-center">
                  <p>
                    <b data-translate="footer_5_6">Find us on social media</b>
                  </p>
                </div>
                <div className="contact-row social-links text-center">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/pages/Al-Rajhi-Bank-Malaysia/127604137252459"
                    aria-label="alrajhi bank Malaysia on Facebook"
                  >
                    <i className="bi bi-facebook" style={{ color: 'rgba(0, 0, 69, 0.70)' }}></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/alrajhibankmalaysia/"
                    aria-label="alrajhi bank Malaysia on Instagram"
                  >
                    <i className="bi bi-instagram" style={{ color: 'rgba(0, 0, 69, 0.70)' }}></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.tiktok.com/@alrajhibankmalaysia"
                    aria-label="alrajhi bank Malaysia on TikTok"
                  >
                    <i className="bi bi-tiktok" style={{ color: 'rgba(0, 0, 69, 0.70)' }}></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/@alrajhibankMalaysiaOfficial"
                    aria-label="alrajhi bank Malaysia on YouTube"
                  >
                    <i className="bi bi-youtube" style={{ color: 'rgba(0, 0, 69, 0.70)' }}></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/arbmy"
                    aria-label="alrajhi bank Malaysia on LinkedIn"
                  >
                    <i className="bi bi-linkedin" style={{ color: 'rgba(0, 0, 69, 0.70)' }}></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex container flex-column flex-xl-row align-items-start border-top mt-4 pt-4 justify-content-between">
          <div className="d-flex flex-column mb-3 order-2 order-xl-1">
            <div className="d-flex flex-row flex-wrap gap-3">
              <Link href="/treat-customer-fairly-charter">
                <span>Treat Customer Fairly Charter</span>
              </Link>{' '}
              |
              <Link href="/client-charter">
                {' '}
                <span>Client Charter</span>
              </Link>
              |
              <Link href="/privacy-policy">
                {' '}
                <span>Privacy Policy</span>
              </Link>{' '}
              |
              <Link href="/tnc">
                {' '}
                <span>Terms & Conditions</span>
              </Link>{' '}
              |
              <Link href={tnc} target="_blank" rel="noopener noreferrer">
                <span>Terms of Use</span>
              </Link>
              |
              <Link href="/fraud-awareness">
                <span>Fraud Awareness</span>
              </Link>
              |
              <Link href={PIDM_DIS} target="_blank" rel="noopener noreferrer">
                <span>PIDM DIS Brochure</span>
              </Link>
            </div>
            <p className="text-left mt-3">
              <span data-translate="footer_6_1">
                Copyright © {year} Al Rajhi Banking & Investment Corporation (Malaysia) Bhd
              </span>
              <br />
              <span data-translate="footer_6_2">200501036909 (719057-X). All rights reserved.</span>
            </p>
          </div>
          <div className="order-1 order-xl-2 mb-3 mb-xl-0">
            {/* Explicit size: the source SVG carried a 125x93 intrinsic size and
                this img has no CSS width, so layout followed the asset. The WebP
                replacement ships at 2x for retina, so the size must be pinned
                here or the logo renders double. Also removes the CLS. */}
            <img
              src={pidmLogo.src}
              alt="PIDM"
              width={125}
              height={93}
              loading="lazy"
              decoding="async"
              className="d-inline-block align-top"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainFooter
